import { render, staticRenderFns } from "./KpiSoporteTecnico.vue?vue&type=template&id=f76c6980&"
import script from "./KpiSoporteTecnico.vue?vue&type=script&lang=js&"
export * from "./KpiSoporteTecnico.vue?vue&type=script&lang=js&"
import style0 from "./KpiSoporteTecnico.vue?vue&type=style&index=0&id=f76c6980&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports